var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBathroomIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bathroom-icon",
    transform: "translate(-5367 -485)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_553",
    "data-name": "Rectangle 553",
    width: 31,
    height: 31,
    transform: "translate(5367 485)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bed-icon",
    d: "M26.669,14.446H5.889V5.889A2.445,2.445,0,0,1,8.334,3.445h2.445a2.445,2.445,0,0,1,2.247,1.484,4.278,4.278,0,0,0-2.858,4.017v1.834A1.222,1.222,0,0,0,11.39,12H17.5a1.222,1.222,0,0,0,1.222-1.222V8.945a4.278,4.278,0,0,0-3.178-4.117A4.889,4.889,0,0,0,10.779,1H8.334A4.889,4.889,0,0,0,3.445,5.889v8.556H2.222a1.222,1.222,0,1,0,0,2.445H3.445V21.78a3.667,3.667,0,0,0,2.445,3.442v1.447a1.222,1.222,0,0,0,2.445,0V25.447H20.558v1.222a1.222,1.222,0,0,0,2.445,0V25.222a3.667,3.667,0,0,0,2.445-3.442V16.891h1.222a1.222,1.222,0,0,0,0-2.445Zm-10.39-5.5v.611H12.612V8.945a1.834,1.834,0,1,1,3.667,0ZM23,21.78A1.222,1.222,0,0,1,21.78,23H7.112A1.222,1.222,0,0,1,5.889,21.78V16.891H23Z",
    transform: "translate(5368.121 486.501)",
    fill: "#4332d5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathroomIcon);
export default __webpack_public_path__ + "static/media/bathroom-icon.c4f0c1d3.svg";
export { ForwardRef as ReactComponent };